import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import "../styles/AuthCommon.css";
import "../styles/ElegantLogin.css";
import PrimaryButton from "../../../shared/components/ui/buttons/PrimaryButton";
import InputField from "../../../shared/components/ui/forms/InputField";
import { Heart, Crown, Sparkles, Mail, Send } from "lucide-react";
import { getBaseUrl } from "../../../config/urls";

/**
 * パスワードリセットリクエストページ
 */
export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [showNextButton, setShowNextButton] = useState(false);
  const navigate = useNavigate();

  const urlBase = getBaseUrl();
  const urlResetPasswordRequest = urlBase + `/api/auth/reset-password-request`;

  const validateEmail = (email: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!email) return setMessage("メールアドレスを入力してください。");
    if (!validateEmail(email)) return setMessage("正しいメールアドレスを入力してください。");

    setLoading(true);
    setMessage("");

    try {
      const res = await fetch(`${urlResetPasswordRequest}?email=${encodeURIComponent(email)}`, {
        method: "POST",
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        const errMsg = (data as any).message || "送信中にエラーが発生しました。";
        setMessage(errMsg);
        setLoading(false);
        return;
      }

      setMessage((data as any).message || "確認コードを送信しました。メールを確認してください！");
      setShowNextButton(true);
    } catch (err) {
      console.error("Reset password request error:", err);
      setMessage("サーバーに接続できません。インターネット接続を確認してください。");
    } finally {
      setLoading(false);
    }
  };

  const handleNext = () => {
    navigate("/auth/resetPasswordConfirm", { state: { email } });
  };

  return (
    <div className="elegant-login-container">
      <div className="elegant-login-background">
      </div>
      
      <form onSubmit={handleSubmit} className="elegant-login-card">
        {/* ヘッダー装飾 */}
        <div className="elegant-login-header">
          <div className="header-decoration">
          </div>
          <h1 className="elegant-login-title">
            Photo Memorial
          </h1>
          <p className="elegant-login-subtitle">Wedding Memory Management</p>
        </div>

        {/* パスワードリセットフォーム */}
        <div className="elegant-form-section">
          <h2 className="elegant-form-title">パスワードをお忘れですか？</h2>
          <p className="elegant-forgot-description">
            メールアドレスを入力してください。<br />
            パスワードをリセットするためのコードをメールでお送りします。
          </p>
          
          <div className="elegant-input-group">
            <div className="input-icon">
              <Mail size={20} />
            </div>
            <InputField
              type="email"
              placeholder="メールアドレス"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="elegant-input"
              disabled={showNextButton}
            />
          </div>

          {!showNextButton && (
            <PrimaryButton type="submit" disabled={loading} className="elegant-login-button">
              {loading ? (
                "送信中..."
              ) : (
                <>
                  <Send size={20} />
                  コード送信
                </>
              )}
            </PrimaryButton>
          )}

          {message && (
            <div className="elegant-message">
              <p>{message}</p>
            </div>
          )}

          {showNextButton && (
            <PrimaryButton type="button" onClick={handleNext} className="elegant-login-button">
              <>
                <Heart size={20} />
                次へ
              </>
            </PrimaryButton>
          )}

          <div className="elegant-links">
            <Link to="/auth/login" className="elegant-link">
              <span>ログインページに戻る</span>
            </Link>
          </div>
        </div>

        {/* フッター装飾 */}
        <div className="elegant-login-footer">
          <div className="footer-decoration">
            <div className="decoration-line"></div>
            <Heart className="footer-heart" />
            <div className="decoration-line"></div>
          </div>
          <p className="footer-text">Elegant Password Reset for Special Moments</p>
        </div>
      </form>
    </div>
  );
}
